export const featuredCardRatio = `calc(450/560)`;
export const featuredCardRatioMobile = `calc(450/820)`;
export const featuredCardRatioTablet = `calc(450/820)`;
export const tinyCardRatio = `calc(200/267)`;
export const tinyCardRatioPc = `calc(200/260)`;
